import React, { ReactNode, useState } from 'react';

import { useAnalytics } from '../../../contexts/AnalyticsContext/AnalyticsContext';
import { useUserInfo } from '../../../helpers/hooks/useUserInfo';
import { AppDownloadModal } from '../../AppDownloadModal/AppDownloadModal';
import { CardButton } from '../CardButton';
import { LinkCard } from '../LinkCard/LinkCard';

interface IProps {
  to: string;
  postId: string;
  targetId: string;
  userNickname: string;
  children: ReactNode;
  source?: string;
}

export const CatchCard = ({
  to,
  postId,
  targetId,
  userNickname,
  children,
  source = 'CatchCard',
}: IProps) => {
  const { currentPage } = useAnalytics();
  const [isAppDownloadModalOpen, setIsAppDownloadModalOpen] = useState(false);
  const { isLoggedIn } = useUserInfo();

  return isLoggedIn ? (
    <LinkCard
      to={to}
      eventProperties={{
        source: source,
        source_id: postId,
        target: 'catch',
        target_id: targetId,
        page: currentPage,
      }}
      className="relative grid h-auto place-self-auto overflow-hidden rounded-sm bg-white hover:shadow-md"
    >
      {children}
    </LinkCard>
  ) : (
    <CardButton
      eventProperties={{
        source: source,
        source_id: postId,
        target: 'appdownloadmodal',
        target_id: targetId,
        page: currentPage,
      }}
      ariaLabel="View other catches from this user"
      onClick={() => {
        setIsAppDownloadModalOpen(true);
      }}
      className="relative grid h-auto place-self-auto overflow-hidden rounded-sm bg-white hover:shadow-md"
    >
      {children}
      <AppDownloadModal
        appDownloadSource={source}
        appDownloadSourceId={postId}
        modalHeader={`See all catches from ${userNickname} in the Fishbrain app`}
        modalText="Download the app to see more info about your favorite anglers, ability to follow them and see what they catch next"
        showTextOnMobile
        isModalOpen={isAppDownloadModalOpen}
        onCloseModal={() => setIsAppDownloadModalOpen(false)}
      />
    </CardButton>
  );
};
